export default __webpack_public_path__ + "static/media/GitLab_Logo.118f488d.svg";